<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <div slot="header">
          <b-row>
            <b-col cols="6">
              <span>{{ $t('global.role_new_title') }}</span>
            </b-col>
          </b-row>
        </div>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col cols="12" md="8">
              <b-form-group>
                <label>{{ $t('global.title') }}</label>
                <b-form-input type="text" :placeholder=" $t('global.role_title_placeholder') "
                  :class="{ 'is-invalid' : errorMsg.name}"
                  v-model="role"/>
                <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
              </b-form-group>
              <b-form-checkbox-group stacked :options="allPermissions" v-model="rolePermissions"/>
            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="onSave()">
            <b-spinner v-if="spinners.isSaving" type="grow" small/>
            {{ $t('global.save') }}
          </b-button>
          <router-view :to="{ name: 'Roles' }">
            <b-button type="reset" variant="info" class="ml-2">{{ $t('global.cancel') }}</b-button>
          </router-view>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      role: '',
      rolePermissions: [],
      allPermissions: [],
      errorMsg: {}
    };
  },
  components: {},
  computed: {
    ...mapGetters('Roles', [
      'roleCreateData',
      'roleCreate'
    ]),
  },
  watch: {
    roleCreateData: {
      handler: function () {
        if (this.roleCreateData.status === statuses.LOADED) {
          this.fillData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    roleCreate: {
      handler: function () {
        this.spinners.isSaving = false;
        this.errorMsg = {};
        if (this.roleCreate.status === statuses.LOADED) {
          this.alertSuccess();
          this.$router.push({ name: 'RoleUpdate', params: { id: this.roleCreate.data.id } });
        } else if (this.roleCreate.status === statuses.ERROR) {
          this.alertError();
          this.errorMsg = this.roleCreate.data.data.errors;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Roles', [
      VT.ROLE_CREATE_DATA,
      VT.ROLE_CREATE
    ]),
    fillData() {
      const permissions = [];

      if (this.roleCreateData.data.permissions) {
        forEach(this.roleCreateData.data.permissions, (permission) => {
          permissions.push({
            value: permission['id'],
            text: this.$t(permission['name'])
          });
        });
      }
      this.allPermissions = permissions;
    },
    getData() {
      this.ROLE_CREATE_DATA();
    },
    onSave() {
      this.spinners.isSaving = true;
      this.ROLE_CREATE({ name: this.role, permissions: this.rolePermissions });
    },
  }
};

</script>

<style scoped>
</style>
